import React from 'react';
import './styles.css';

const faqs = [
  {
    q: 'Do you deliver fresh fish across India?',
    a: 'Yes. FR Fisheries operates 231 coastal hubs with temperature-controlled logistics to deliver fresh seafood across major Indian metros and tier-2 cities.',
  },
  {
    q: 'How often is your catalog updated?',
    a: 'Our live catalog refreshes every 15 minutes with landed volumes, species availability, and grades so buyers can place timely orders.',
  },
  {
    q: 'Can restaurants request custom cuts or grading?',
    a: 'Absolutely. We support custom cuts, filleting, grading, and vacuum packing with yield guarantees tuned to restaurant prep standards.',
  },
  {
    q: 'What cold-chain controls do you use?',
    a: 'IoT sensors track temperature end-to-end; any deviation triggers automated escalation and route adjustments to keep seafood within safe ranges.',
  },
];

function FAQ() {
  return (
    <section className="faq scroll-reveal" id="faq">
      <div className="faq-head">
        <p className="pill">FAQ</p>
        <h2>Seafood sourcing answers</h2>
        <p>Everything you need to know about FR Fisheries procurement, cold-chain, and service.</p>
      </div>
      <div className="faq-grid">
        {faqs.map((item) => (
          <article key={item.q} className="faq-item">
            <h3>{item.q}</h3>
            <p>{item.a}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
